function getDay(): { today: number; tomorrow: number } {
  const today = new Date().getDay();
  const tomorrow = today < 7 ? new Date().getDay() + 1 : 1;

  return { today, tomorrow };
}
export default getDay;
